import { gql } from 'graphql-request';
import {
  LifestyleID,
  LifestyleUUID,
  LifestyleImageID,
  LifestyleImageName,
  LifestyleImageFile,
  LifestyleImageSize,
  LifestyleImageUUID,
  LifestyleNanoID
} from '../lifestylesTypes';

export interface FetchShowLifestyleImageQueryResponseImage {
  id: LifestyleImageID;
  uuid: LifestyleImageUUID;
  file: LifestyleImageFile;
  size: LifestyleImageSize;
  name: LifestyleImageName;
}

export interface FetchShowLifestyleImageQueryResponse {
  id: LifestyleID;
  nanoId: LifestyleNanoID;
  uuid: LifestyleUUID;
  image: FetchShowLifestyleImageQueryResponseImage;
}

export const FETCH_SHOW_LIFESTYLE_IMAGE_QUERY = gql`
  query ShowLifestyleImage($uuid: ID!) {
    lifestyle(uuid: $uuid) {
      id
      nanoId
      uuid
      image {
        id
        uuid
        size
        name
        file
      }
    }
  }
`;
